const SimpleRequest = ({ request }) => {
  return (
    <div>
      {request.steps.map((x) => (
        <div key={x.guid}> {x.question} </div>
      ))}
    </div>
  );
};
export default SimpleRequest;
